import { Modal, Form, Row, Col, Space, Button, Flex, Upload, Alert, } from "antd";
import { useState } from "react";
import { FormDatePicker, FormInput, FormSelect, } from "components/form/FormProvide";
import { useTranslation } from "react-i18next";
import FormAntd from "components/form/FormProvide/FormAntd";
import { formatDate } from "utils/formatter";
import { ReactComponent as UploadIcon } from "../../../assets/icon/uploadIcon.svg";
import FormItem from "antd/es/form/FormItem";

const { Dragger } = Upload;

const EmployeeEditWelfare = ({
  isEditModalOpen,
  setIsEditModalOpen,
  onDraft = () => { },
  record,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [fileList, setFileList] = useState([]);

  const onSubmit = (values) => {
    console.log("แก้ไขสวัสดิการ:", values);
    console.log("ไฟล์ที่อัปโหลด:", fileList);
    setIsEditModalOpen(false);
  };

  const onCancel = () => {
    form.resetFields();
    setFileList([]);
    setIsEditModalOpen(false);
  };

  return (
    <Modal open={isEditModalOpen} footer={null} width={700}  maskClosable={false} closable={false}>
      <FormItem
        shouldUpdate={(prev, curv) => {
          return false;
        }}
      >
        {({ getFieldValue, setFieldValue, resetFields }) => (
          <Space direction="vertical" size={16} style={{ width: "100%" }}>
            <h2>{t("welfare_list.Request_for_reimbursement_of _expenses")}</h2>
            <div>{t("welfare_list.Create_an_expense_reimbursement_request")}</div>

            <FormAntd form={form} layout="vertical" onFinish={onSubmit}>
              <Row gutter={[18, 16]}>
                <Col span={24}>
                  <FormInput
                    name="welfare"
                    label={t("employee.welfare.header")}
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={24}>
                  <FormInput
                    name="description"
                    label={t("employee.label.description")}
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={12}>
                  <FormInput
                    name="numberRights"
                    label={t("welfare_list.Number_of_rights")}
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={12}>
                  <FormInput
                    name="amount"
                    label={t("welfare_list.Amout")}
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={24}>
                  <FormInput
                    name="address"
                    label={t("welfare_list.Welfare_recipients")}
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={24}>
                  <FormSelect
                    name="welfareType"
                    label={t("welfare_list.Expense_type")}
                    placeholder={t("company_profile.label.please_select")}
                    size="large"
                    required
                  
                  />
                </Col>

                <Col span={24}>
                  <FormSelect
                    name="projectId"
                    label={t("my_timesheet.label.select_proj")}
                    placeholder={t("company_profile.label.please_select")}
                    size="large"
                    required
                    style={{ marginBottom: "20px" }}
                  />
                </Col>

                <Col span={24}>
                  <FormInput
                    name="amountBaht"
                    label="จำนวนเงิน (บาท)"
                    placeholder=""
                    size="large"
                    required
                  />
                </Col>

                <Col span={24}>
                  <FormInput
                    name="extraDescription"
                    label={t("welfare_list.Description")}
                    placeholder=""
                    size="large"
                    type="textarea"
                    rows={4}
                    required
                  />
                </Col>

                <Col span={24}>
                  <FormSelect
                    name="rights"
                    label={t("welfare_list.Select_user_rights")}
                    placeholder={t("company_profile.label.please_select")}
                    size="large"
                    required
                  />
                </Col>

                <Col span={12}>
                  <FormDatePicker
                    name="startDate"
                    label={t("start-date")}
                    placeholder={t("common.pleaseSelect")}
                    size="large"
                    format={formatDate()}
                    required
                  />
                </Col>

                <Col span={12}>
                  <FormDatePicker
                    name="endDate"
                    label={t("changeshift.label.enddate")}
                    placeholder={t("common.pleaseSelect")}
                    size="large"
                    format={formatDate()}
                    required
                  />
                </Col>

                <Col span={24}>
                  <Form.Item
                    colon={false}
                    label={
                      <span style={{ fontSize: "16px", color: "#475467" }}>
                        {t("welfare_list.Attached_file")}
                      </span>
                    }
                    labelCol={{ span: 24 }}
                    wrapperCol={{ span: 24 }}
                  >
                    <Dragger
                      fileList={fileList}
                      type="drag"
                      maxCount={1}
                      listType="picture"
                      showUploadList={true}
                      style={{ backgroundColor: "white", borderRadius: "12px" }}
                      beforeUpload={() => false}
                      onChange={(info) => {
                        const fileName = info.file?.name?.toLowerCase();
                        if (
                          fileName &&
                          !(
                            fileName.endsWith("png") || fileName.endsWith("jpeg") || fileName.endsWith("xlsx") ||fileName.endsWith("pdf")
                          )
                        ) {
                          Alert.error("ระบบรองรับไฟล์ PNG, JPEG, XLSX, PDF");
                          setFileList([]);
                        } else if (fileName) {
                          setFileList([info.file]);
                        }
                      }}
                      onRemove={() => setFileList([])}
                    >
                      <Flex
                        style={{ height: "10vh", rowGap: "14px" }}
                        vertical
                        justify="center"
                        align="center"
                      >
                        <Flex style={{ width: "10%" }}>
                          <UploadIcon
                            style={{ fontSize: 30, color: "#2CADE7" }}
                          />
                        </Flex>
                        <Flex>
                          <span
                            style={{ color: "#2CADE7", fontWeight: "bold" }}
                          >
                            {t("common.choose_file")}
                          </span>
                          &nbsp;
                          <span style={{ color: "#475467" }}>
                            {t("common.upload_dnd")}
                          </span>
                        </Flex>
                      </Flex>
                    </Dragger>

                    {!fileList?.length > 0 && (
                      <Flex style={{ marginTop: "15px" }} vertical>
                        <span style={{ color: "#475467" }}>
                          {t("common.file_support_welfare")}
                        </span>
                      </Flex>
                    )}
                  </Form.Item>
                </Col>

                <Col span={24}>
                  <Row justify="end" gutter={10} style={{ marginTop: 20 }}>
                    <Col>
                      <Button
                        type="default"
                        onClick={onCancel}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                        }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        type="default"
                        onClick={onDraft}
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                        }}
                      >
                        {t("common.draft").toUpperCase()}
                      </Button>
                    </Col>

                    <Col>
                      <Button
                        htmlType="submit"
                        type="primary"
                        style={{
                          height: "40px",
                          borderRadius: "8px",
                          backgroundColor: "var(--button-color)",
                        }}
                      >
                        {t("common.confirm").toUpperCase()}
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </FormAntd>
          </Space>
        )}
      </FormItem>
    </Modal>
  );
};

export default EmployeeEditWelfare;
